import EntryActionTypes from '../constants/EntryActionTypes';

const createCard = (listId, data, autoOpen) => ({
  type: EntryActionTypes.CARD_CREATE,
  payload: {
    listId,
    data,
    autoOpen,
  },
});

const handleCardCreate = (card) => ({
  type: EntryActionTypes.CARD_CREATE_HANDLE,
  payload: {
    card,
  },
});

const updateCard = (id, data) => ({
  type: EntryActionTypes.CARD_UPDATE,
  payload: {
    id,
    data,
  },
});

const updateCurrentCard = (data) => ({
  type: EntryActionTypes.CURRENT_CARD_UPDATE,
  payload: {
    data,
  },
});

const handleCardUpdate = (card) => ({
  type: EntryActionTypes.CARD_UPDATE_HANDLE,
  payload: {
    card,
  },
});

const moveCard = (id, listId, index = 0) => ({
  type: EntryActionTypes.CARD_MOVE,
  payload: {
    id,
    listId,
    index,
  },
});

const moveCurrentCard = (listId, index = 0) => ({
  type: EntryActionTypes.CURRENT_CARD_MOVE,
  payload: {
    listId,
    index,
  },
});

const transferCard = (id, boardId, listId, index = 0) => ({
  type: EntryActionTypes.CARD_TRANSFER,
  payload: {
    id,
    boardId,
    listId,
    index,
  },
});

const transferCurrentCard = (boardId, listId, index = 0) => ({
  type: EntryActionTypes.CURRENT_CARD_TRANSFER,
  payload: {
    boardId,
    listId,
    index,
  },
});

const deleteCard = (id) => ({
  type: EntryActionTypes.CARD_DELETE,
  payload: {
    id,
  },
});

const archiveCard = (id) => ({
  type: EntryActionTypes.CARD_ARCHIVE,
  payload: {
    id,
  },
});

const restoreCard = (id) => ({
  type: EntryActionTypes.CARD_RESTORE,
  payload: {
    id,
  },
});

const handleCardRestore = (card) => ({
  type: EntryActionTypes.CARD_RESTORE_HANDLE,
  payload: {
    card,
  },
});

const cloneCard = (id) => ({
  type: EntryActionTypes.CARD_CLONE,
  payload: {
    id
  },
});

const handleCardClone = (card) => ({
  type: EntryActionTypes.CARD_CLONE_HANDLE,
  payload: {
    card,
  },
});

const cloneCurrentCard = () => ({
  type: EntryActionTypes.CURRENT_CARD_CLONE,
  payload: {},
});

const deleteCurrentCard = () => ({
  type: EntryActionTypes.CURRENT_CARD_DELETE,
  payload: {},
});

const archiveCurrentCard = () => ({
  type: EntryActionTypes.CURRENT_CARD_ARCHIVE,
  payload: {},
});

const handleCardDelete = (card) => ({
  type: EntryActionTypes.CARD_DELETE_HANDLE,
  payload: {
    card,
  },
});

const handleCardArchive = (card) => ({
  type: EntryActionTypes.CARD_ARCHIVE_HANDLE,
  payload: {
    card,
  },
});

export default {
  createCard,
  handleCardCreate,
  updateCard,
  updateCurrentCard,
  handleCardUpdate,
  moveCard,
  moveCurrentCard,
  transferCard,
  transferCurrentCard,
  deleteCard,
  archiveCard,
  restoreCard,
  handleCardRestore,
  deleteCurrentCard,
  handleCardArchive,
  handleCardDelete,
  archiveCurrentCard,
  handleCardClone,
  cloneCard,
  cloneCurrentCard
};
